export function convertToKebabCase(text) {
  return text
    .replace(/[^0-9a-z ]/gi, '')
    .toLowerCase()
    .split(' ')
    .join('-')
}
